export enum IdStateNumberMunicipal {
  Disponibile = '1',
  Utilizzato = '2',
  Scartato = '3',
  EventoAcquisito = '4',
}

export const getNameStateNumberMunicipal = (id?: string): string => {
  if (!id) {
    return '';
  }

  switch (id) {
    case IdStateNumberMunicipal.Disponibile:
      return 'Disponibile';
    case IdStateNumberMunicipal.Utilizzato:
      return 'Utilizzato';
    case IdStateNumberMunicipal.Scartato:
      return 'Scartato';
    case IdStateNumberMunicipal.EventoAcquisito:
      return 'Evento acquisito';
    default:
      return id;
  }
};
